import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../../domain/user/service/user.service';
import { ToastService } from '../services/toast.service';

export const authGuard: CanActivateFn = async () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const toast = inject(ToastService);

  if (userService.currentUserValue) {
    return true;
  }

  const user = await firstValueFrom(userService.fetchCurrentUser());
  if (user) {
    return true;
  }

  toast.show('로그인이 필요합니다');
  return router.parseUrl('/signin');
};
